import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { CSSTransition } from 'react-transition-group';

import { useCallContext } from '@gem/call/CallView/CallView.context';

import styles from './AnimatedRightPanel.styles.m.css';
import transitions from './AnimatedRightPanel.transitions.m.css';
import { RequestedPermissionsPanel } from './RequestedPermissionsPanel/RequestedPermissionsPanel';
import { RightPanel } from './RightPanel/RightPanel';

const MemberListCSSTransitionClasses = {
  enter: transitions.memberListEnter,
  enterActive: transitions.memberListEnterActive,
  exit: transitions.memberListExit,
  exitActive: transitions.memberListExitActive,
};

export const AnimatedRightPanel = observer(() => {
  const { call } = useCallContext();

  return (
    <>
      <CSSTransition
        in={call.viewState.isMembersShown}
        classNames={MemberListCSSTransitionClasses}
        timeout={100}
        mountOnEnter
        unmountOnExit
      >
        <div className={styles.container}>
          <RightPanel />
        </div>
      </CSSTransition>
      <CSSTransition
        in={call.viewState.isPermissionsRequestsShown}
        classNames={MemberListCSSTransitionClasses}
        timeout={100}
        mountOnEnter
        unmountOnExit
      >
        <div className={classNames(styles.container, styles.containerRequests)}>
          <RequestedPermissionsPanel />
        </div>
      </CSSTransition>
    </>
  );
});
